import { type ReactNode } from 'react';
import { motion, useReducedMotion } from 'motion/react';
import { EASE } from '@/shared/motion/transitions';

/**
 * Route-level transition — a transparent, full-height passthrough (no bg / no
 * padding) that fades + rises on enter and fades up on exit. Keyed on the
 * pathname inside an `AnimatePresence mode="wait"` in VaultLayout, so each route
 * change animates without disturbing the `.page` / `.main` scroll layout.
 * Honors reduced motion (fade only, no transform).
 */
export default function PageTransition({ children }: { children: ReactNode }) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className="h-full"
      initial={reduce ? { opacity: 0 } : { opacity: 0, y: 8 }}
      animate={reduce ? { opacity: 1 } : { opacity: 1, y: 0 }}
      exit={reduce ? { opacity: 0 } : { opacity: 0, y: -6 }}
      transition={{ duration: 0.24, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}
